<template>
  <div class="Slider">
    <div ref="slider" class="Slider-line" @scroll="sliderWasChanged">
      <slot name="content"></slot>
    </div>
    <div v-if="isScrollLeft || isScrollRight" class="Slider-buttons">
      <div class="Slider-buttons--button" :class="{'disabled': !isScrollLeft}" @click="scrollLeft">
        <font-awesome-icon :icon="['fas', 'chevron-left']"/>
      </div>
      <div class="Slider-buttons--button" :class="{'disabled': !isScrollRight}" @click="scrollRight">
        <font-awesome-icon :icon="['fas', 'chevron-right']"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Slider',
  data: () => ({
    isScrollLeft: false,
    isScrollRight: false,
    scrollStep: 387,
    isMounted: false
  }),
  mounted() {
    this.sliderWasChanged()
  },
  updated() {
    this.sliderWasChanged()
  },
  methods: {
    getCardTitle(key) {
      if (key === 'personalization') return 'Personalization'
      else if (key === 'activeIngredients') return 'Active Ingredients'
      else if (key === 'naturalClean') return 'Natural & Clean'
      else if (key === 'foodIngredients') return 'Food Ingredients'
    },
    sliderWasChanged() {
      const slider = this.$refs.slider
      this.isScrollLeft = slider.scrollLeft !== 0
      this.isScrollRight = slider.scrollLeft + slider.offsetWidth !== slider.scrollWidth
    },
    scrollRight () {
      const slider = this.$refs.slider
      if (this.isScrollRight) {
        slider.scrollTo({
          left: slider.scrollLeft + this.scrollStep,
          behavior: 'smooth',
        })
      }
    },
    scrollLeft () {
      const slider = this.$refs.slider
      if (this.isScrollLeft) {
        slider.scrollTo({
          left: slider.scrollLeft - this.scrollStep,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.Slider {
  margin-top: 40px;
  width: 100vw;
  &-line {
    display: flex;
    flex-wrap: nowrap;
    width: initial;
    overflow-x: auto;
    &::-webkit-scrollbar { width: 0; }
    @media screen and (min-width: $max-container-width) {
      padding: 0 calc((100vw - #{$max-container-width})/2);
    }
  }
  &-buttons {
    display: flex;
    justify-content: flex-end;
    margin-right: 7%;
    &--button {
      background: #FFFFFF;
      border: 1px solid #EBEBEB;
      border-radius: 50px;
      padding: 22px 25px;
      box-shadow: 0 4px 15px rgba(21, 17, 71, 0.05);
      margin: 0 20px 2px;
      transition: all .2s linear 0ms;
      &.disabled {
        color: #D0CFDA;
        &:hover {
          cursor: default;
          border: 2px solid rgb(208, 207, 218);
        }
      }
      &:hover {
        margin-bottom: 0;
        cursor: pointer;
        border: 2px solid $color;
      }
      &:last-child {
        margin-right: 10px;
      }
    }
    @media screen and (min-width: $max-container-width) {
      margin-right: calc((100vw - #{$max-container-width})/2);
    }
  }
  @media screen and (min-width: $max-container-width) {
    margin-left: calc((100vw - #{$max-container-width})/2 * -1);
  }
  @media screen and (max-width: 775px) {
    margin-top: 10px;
  }
}
</style>
